import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { apiAssessors } from 'helpers/decorators/api'
import { get } from 'lodash'
import { connect } from 'react-redux'
import styles from './affiliations-overview.styl'
import Affiliation from './Affiliation'

@apiAssessors()
@connect(({ auth }) => ({
  authUserId: get(auth, 'user.personId'),
}))
class AffiliationsOverview extends Component {
  static propTypes = {
    onGetAssessorOverview: PropTypes.func,
    assessor: PropTypes.any,
  }

  componentDidMount() {
    this.props.onGetAssessorOverview(get(this.props, 'authUserId'))
  }

  render() {
    const data = get(this.props.assessor, 'assessors.affiliationsOverview.data') ?? []

    return (
      <div className={styles.overview}>
        {data.map(item => {
          const key = `${item.assessor.id}-${item.organization.id}`

          return (
            <div>
               <Affiliation id={key} key={key} form={`affiliations-overview-${key}`} item={item} />
            </div>)
        })}
      </div>
    )
  }
}

export default AffiliationsOverview
